import script from "./insight-metric-pill.vue?vue&type=script&setup=true&lang=ts"
export * from "./insight-metric-pill.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__